<template>
  <Header header__white="header__white" />
  <Breadcrumb :title="$route.params.name == 'fairTech' ? 'Fair Tech' : $route.params.name == 'fairPrice' ? 'Fair Price' : $route.params.name == 'pharmInfo' ? 'Pharm Info' : $route.params.name == 'productInfo' ? 'Product Info' : 'Marketplace'" :subtitle="$route.params.name == 'fairTech' ? 'Fair Tech' : $route.params.name == 'fairPrice' ? 'Fair Price' : $route.params.name == 'pharmInfo' ? 'Pharm Info' : $route.params.name == 'productInfo' ? 'Product Info' : 'Marketplace'" />
  <Fairtech v-if="$route.params.name == 'fairTech'" />
  <FairPrice v-if="$route.params.name == 'fairPrice'" />
  <PharmInfo v-if="$route.params.name == 'pharmInfo'" />
  <ProductInfo v-if="$route.params.name == 'productInfo'" />
  <Marketplace v-if="$route.params.name == 'marketplace'" />
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Home/Header.vue';
import Breadcrumb from '../components/common/Breadcrumb.vue';
import Fairtech from '../components/common/fairtech.vue';
import FairPrice from '../components/common/fairPrice.vue';
import PharmInfo from '../components/common/pharmInfo.vue';
import ProductInfo from '../components/common/productInfo.vue';
import Marketplace from '../components/common/marketplace.vue';
import Footer from '../components/Home/Footer.vue';

export default {
  name:'AboutPage',
  components:{
    Header,
    Breadcrumb,
    Fairtech,
    FairPrice,
    PharmInfo,
    ProductInfo,
    Marketplace,
    Footer,
  },
  data(){
    return{
      routeName: this.$route.params.name
    }
  }
}
</script>
